<my-header></my-header>

<div class="my-account">
    <div class="left-arrow" (click)="goBack()">
    <img alt="home" class="home" src="./assets/images/arrow.svg" />
      <span class="back-text">Back</span>
    </div>

    
    <div class="title"><!--<span>My Account</span>--></div>
</div>
<div class="profile">
    <div class="user-img">
        <div class="">
            <img class="profileImg" [src]="avatarUrl" alt="Profile Image"/>
            <span class="material-symbols-outlined profile_edit" (click)="showPopup()">edit</span>
        </div>
        <div class="user-info">
            <div class="user-name">{{patientProfileData?.patientInfo?.lastname | titlecase}}, 
                {{patientProfileData?.patientInfo?.firstname | titlecase}} 
                {{patientProfileData?.patientInfo?.middlename | titlecase}}</div>
        </div>        
    </div>
    <div class="userdata" #profileInfo>
        <div class="userInfo userInfo--1"> 
            <div class="title">Contact Information</div>
            <div class="info">
                <div class="info-item">Email<div class="info-value">{{patientProfileData?.patientInfo?.email}}</div></div>
                <div class="info-item">DOB<div class="info-value">{{patientProfileData?.patientInfo?.dob}}</div></div>
                <div class="info-item">Phone<div class="info-value">{{PatientPhoneNo}}</div></div>
                <div class="info-item">Location<div class="info-value">
                    {{ (patientProfileData?.patientInfo?.address1 ? patientProfileData.patientInfo.address1.toUpperCase() + ', ' : '') +
                        (patientProfileData?.patientInfo?.address2 ? patientProfileData.patientInfo.address2.toUpperCase() + ', ' : '') +
                        (patientProfileData?.patientInfo?.city ? patientProfileData.patientInfo.city.toUpperCase() + ', ' : '') +
                        (patientProfileData?.patientInfo?.state ? patientProfileData.patientInfo.state.toUpperCase() + ', ' : '') +
                        (patientProfileData?.patientInfo?.zipcode ? patientProfileData.patientInfo.zipcode.toUpperCase() : '') }}
                </div></div>
            </div> 
        </div>
        <div class="userInfo userInfo--2">
            <div id="insuranceNoScroll">
                <div class="title margin_top_24px">Insurances <span class="material-symbols-outlined add_insurance" (click)="openInsuPopup()">add</span><div class="title-value binpcn"></div></div>
                <div class="carousel-container card_zindex">
                        <span class="material-symbols-outlined desktop-only" (click)="showPreviousCard()" [ngClass]="{ disabled: currentCardIndex === 0 }"> arrow_back_ios</span>
                            <div class="info_insurance" *ngIf="isAllCardsVisible">
                                <ng-container *ngIf="patientProfileData?.patientInfo?.insurance[currentCardIndex]">
                                    <div class="insu_info" >
                                            <div class="insu_info_header">
                                            <div class="insu_info_header1 font_size_data">
                                                {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insurancename | uppercase }}
                                            </div>
                                            <div class="insu_info_header2 font_size_data1" *ngIf="patientProfileData?.patientInfo?.insurance[currentCardIndex]?.phoneNumber">
                                                <span class="material-symbols-outlined insu_call">call</span>
                                                {{ displayPhoneNumber(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.phoneNumber) }}

                                            </div>
                                            </div>
                                            <div class="insu_info_name">
                                            <div class="insu_info_name1 font_size_data2">Name of Beneficiary</div>
                                            <div class="insu_info_name2 font_size_data">
                                                {{patientProfileData?.patientInfo?.lastname | titlecase}} 
                                                {{patientProfileData?.patientInfo?.firstname | titlecase}} 
                                                {{patientProfileData?.patientInfo?.middlename | titlecase}}
                                            </div>
                                            </div>
                                            <div class="insu_info_id">
                                            <div class="insu_info_id1">
                                                <div class="insu_info_id1_1 font_size_data2">Ins.ID</div>
                                                <div class="insu_info_id1_2 font_size_data">
                                                {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.policynum || '---' }}
                                                </div>
                                            </div>
                                            <div class="insu_info_id3" *ngIf="patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId">
                                                {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId 
                                                    ? patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId === 1 ? 'PRIMARY' : patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId === 2 ? 'SECONDARY' : 'TERTIARY' : '---'
                                                }}</div>
                                            </div>
                                            <div class="insu_info_bin">
                                                <div class="insu_info_bin1 font_size_data2">BIN# / PCN# / GROUP# / Person Code</div>
                                                <div class="insu_info_bin2 font_size_data">
                                                    {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.binnum || 'N/A') | uppercase}}  
                                                    <span class="small-slash">/</span>
                                                    {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.processorNum || 'N/A') | uppercase}}  <span class="small-slash">/</span>
                                                    {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.groupname || 'N/A') | uppercase}} <span class="small-slash">/</span>
                                                    {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.pernum || '---') | uppercase}}
                                                </div>
                                            </div>
                                    </div>
                                </ng-container>                    
                            </div>
                            <div class="info_insurance" *ngIf="!isAllCardsVisible && !showAllCards">
                                <div class="insu_info">
                                  <div class="insu_info_header">
                                    <div class="insu_info_header1 font_size_data">
                                      {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insurancename | uppercase }}
                                    </div>
                                    <div class="insu_info_header2 font_size_data1" *ngIf="patientProfileData?.patientInfo?.insurance[currentCardIndex]?.phoneNumber">
                                      <span class="material-symbols-outlined insu_call">call</span>
                                      {{ displayPhoneNumber(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.phoneNumber) }}
          
                                    </div>
                                  </div>
                                  <div class="insu_info_name">
                                    <div class="insu_info_name1 font_size_data2">Name of Beneficiary</div>
                                    <div class="insu_info_name2 font_size_data">
                                      {{patientProfileData?.patientInfo?.lastname | titlecase}} 
                                      {{patientProfileData?.patientInfo?.firstname | titlecase}} 
                                      {{patientProfileData?.patientInfo?.middlename | titlecase}}
                                    </div>
                                  </div>
                                  <div class="insu_info_id">
                                    <div class="insu_info_id1">
                                      <div class="insu_info_id1_1 font_size_data2">Ins.ID</div>
                                      <div class="insu_info_id1_2 font_size_data">
                                        {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.policynum || '---' }}
                                      </div>
                                    </div>
                                    <div class="insu_info_id3" *ngIf="patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId">
                                      {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId 
                                          ? patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId === 1 ? 'PRIMARY' : patientProfileData?.patientInfo?.insurance[currentCardIndex]?.insuPriId === 2 ? 'SECONDARY' : 'TERTIARY' : '---'
                                      }}</div>
                                  </div>
                                  <div class="insu_info_bin">
                                    <div class="insu_info_bin1 font_size_data2">BIN# / PCN# / GROUP# / Person Code</div>
                                    <div class="insu_info_bin2 font_size_data">
                                      {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.binnum || 'N/A') | uppercase}} <span class="small-slash">/</span>
                                      {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.processorNum || 'N/A') | uppercase}}  <span class="small-slash">/</span>
                                      {{(patientProfileData?.patientInfo?.insurance[currentCardIndex]?.groupname || 'N/A') | uppercase}}  <span class="small-slash">/</span>
                                       {{ patientProfileData?.patientInfo?.insurance[currentCardIndex]?.pernum || '---' }}
                                    </div>
                                  </div>
                                </div>
                                <div class="carousel-dots desktop-only">
                                  <span
                                    *ngFor="let dot of visibleDots; let i = index"
                                    class="dot"
                                    [class.active]="dot === currentCardIndex"
                                    (click)="patientProfileData?.patientInfo?.insurance?.length > 1 && goToCard(dot)">
                                  </span>
                                </div>                      
                            </div>
                        <span [ngClass]="{ disabled: currentCardIndex === patientProfileData?.patientInfo?.insurance.length - 1 }" class="material-symbols-outlined desktop-only" (click)="showNextCard()">arrow_forward_ios</span>

                <!--Display all cards start-->
                <div class="info_insurance" *ngIf="showAllCards">
                    <ng-container *ngFor="let card of patientProfileData?.patientInfo?.insurance; let i = index">
                        <div class="insu_info" (click)="closeAllCards()">
                                <div class="insu_info_header">
                                <div class="insu_info_header1 font_size_data">
                                    {{ card?.insurancename | uppercase }}
                                </div>
                                <div class="insu_info_header2 font_size_data1" *ngIf="card?.phoneNumber">
                                    <span class="material-symbols-outlined insu_call">call</span>
                                    {{ displayPhoneNumber(card?.phoneNumber) }}

                                </div>
                                </div>
                                <div class="insu_info_name">
                                <div class="insu_info_name1 font_size_data2">Name of Beneficiary</div>
                                <div class="insu_info_name2 font_size_data">
                                    {{patientProfileData?.patientInfo?.lastname | titlecase}} 
                                    {{patientProfileData?.patientInfo?.firstname | titlecase}} 
                                    {{patientProfileData?.patientInfo?.middlename | titlecase}}
                                </div>
                                </div>
                                <div class="insu_info_id">
                                <div class="insu_info_id1">
                                    <div class="insu_info_id1_1 font_size_data2">Ins.ID</div>
                                    <div class="insu_info_id1_2 font_size_data">
                                    {{ card?.policynum || '---' }}
                                    </div>
                                </div>
                                <div class="insu_info_id3" *ngIf="card?.insuPriId">
                                    {{ card?.insuPriId 
                                        ? card?.insuPriId === 1 ? 'PRIMARY' : card?.insuPriId === 2 ? 'SECONDARY' : 'TERTIARY' : '---'
                                    }}</div>
                                </div>
                                <div class="insu_info_bin">
                                    <div class="insu_info_bin1 font_size_data2">BIN# / PCN# / GROUP# / Person Code</div>
                                    <div class="insu_info_bin2 font_size_data"> 
                                        {{(card?.binnum || 'N/A') | uppercase}}  <span class="small-slash">/</span>
                                        {{(card?.processorNum || 'N/A') | uppercase}}  <span class="small-slash">/</span>
                                        {{(card?.groupname || 'N/A') | uppercase}} <span class="small-slash">/</span>
                                        {{ card?.pernum || '---' }}
                                    </div>
                                </div>
                        </div>
                    </ng-container>
                </div>
            </div>
                <!--Display all cards end-->
            </div>
            <div class="insupopup-backdrop" *ngIf="insuPopupOpen"></div>
            <div class="insupopup_modal" *ngIf="insuPopupOpen">
                <div class="insupopup_modal_container">
                    <div class="insupopup_header">
                        <p>Add Insurance</p>
                        <button title="cancel" (click)="closeInsuPopup()">×</button>
                    </div>
                    <span class="insurance_text">Enter insurance details or scan/upload card.</span>
                        <div class="capture_buttons">
                            <button class="cap_buttons" (click)="openCamera('environment')"><span class="material-symbols-outlined">photo_camera</span><span class="text_change">Capture Image</span></button>
                            <button class="cap_buttons" (click)="triggerFileUpload()"><span class="material-symbols-outlined">add_photo_alternate</span><span class="text_change">Upload Image</span></button>
                      </div>
                      <div *ngIf="errorMessage" class="error-message">
                        {{ errorMessage }}
                      </div>
                        <form [formGroup]="InsuCardsFG" (ngSubmit)="saveInsuraceData()">
                            <div class="insupopup_body">
                                <div class="label_text">
                                    <label>BIN<span class="required-asterisk">*</span></label>
                                    <input #binField type="text" formControlName="BIN" 
                                        maxlength="6" minlength="6" required
                                        placeholder="Enter BIN" 
                                        [ngClass]="{
                                            'error-field': isFieldInvalid('BIN'),
                                            'margin_bottom': (isInsuranceExists || isInsuranceInactive)
                                        }"
                                        (input)="restrictToSixDigits(binField, pcnField)"
                                        (blur)="validateAndFocus(binField, pcnField)"
                                        (focus)="skipIfDisabled($event, 'BIN')"
                                        (keypress)="allowOnlyNumbers($event)">
                                    <small *ngIf="isFieldInvalid('BIN')">
                                        BIN must be exactly 6 digits.
                                    </small>
                                </div>
                                <div class="label_text">
                                    <label>PCN</label>
                                    <input #pcnField type="text" formControlName="PCN" maxlength="15" [placeholder]="'Enter PCN'">
                                </div>
                                <div class="label_text" [ngClass]="{
                                    'margin_top': (isInsuranceExists || isInsuranceInactive)
                                  }">
                                    <label>Insurance Name<span class="required-asterisk">*</span></label>
                                    <input type="text" #insType [value]="insuranceCode" formControlName="InsuranceName" maxlength="25" placeholder="Enter Insurance Name"
                                        [required]="true"
                                        [ngClass]="{
                                            'input_disabled': isInsuExists,
                                            'error-field': isFieldInvalid('InsuranceName')
                                          }" (focus)="skipIfDisabled($event, 'PhoneNumber')"
                                          (blur)="validateField('InsuranceName', insType)">
                                          <small *ngIf="isFieldInvalid('InsuranceName')">
                                            Insurance Name is required.
                                        </small>
                                </div>
                                <div class="label_text">
                                    <label>Group Number</label>
                                    <input #grpField type="text" formControlName="GroupNumber" maxlength="35" placeholder="Enter Group Number">
                                </div>
                                <div class="label_text">
                                    <label>Insurance Phone Number</label>
                                    <input #phoneField type="tel" formControlName="PhoneNumber" placeholder="Enter Phone Number" maxlength="15" (input)="onPhoneNumberInput($event)"
                                    [ngClass]="{
                                        'input_disabled': isPhoneExists,
                                      }" (focus)="skipIfDisabled($event, 'PhoneNumber')">
                                </div>
                                <div class="label_text">
                                    <label>Insurance ID<span class="required-asterisk">*</span></label>
                                    <input #policyField type="text" formControlName="PolicyNumber" maxlength="80" placeholder="Enter Insurance ID" [ngClass]="{
                                        'error-field': isFieldInvalid('PolicyNumber')
                                      }" (focus)="skipIfDisabled($event, 'PolicyNumber')" (blur)="validateField('PolicyNumber', policyField)" [required]="true">
                                    <small *ngIf="isFieldInvalid('PolicyNumber')">
                                        Insurance ID is required.
                                    </small>
                                </div>
                                <div class="label_text">
                                    <label>Person Code</label>
                                    <input type="text" formControlName="PersonCode" maxlength="3" placeholder="Enter Person Code">
                                </div>
                                <div class="dropdown-container" #dropdownContainer>
                                    <label for="dropdown" class="dropdown-label">Billing Priority</label>
                                    <div [ngClass]="{ 'placeholder': !selectedOption }" class="dropdown-control"
                                      tabindex="0" (click)="toggleDropdown()">{{ selectedOption?.label || 'Select Billing Priority' }}
                                    </div>
                                    <ul *ngIf="showDropdown" class="dropdown-list">
                                      <li *ngFor="let option of dropdownOptions" (click)="selectOption(option)">{{ option.label }}</li>
                                    </ul>
                                </div>                                                    
                                  <div *ngIf="isInsuranceInactive" class="data_check_exists data_check_inactive desktop-only">
                                    <span class="material-symbols-outlined">error</span>The selected Insurance is inactive, hence cannot be added.
                                  </div>
                            </div>
                            <span 
                                class="insurance_required" 
                                *ngIf="!(InsuCardsFG.get('BIN')?.value && InsuCardsFG.get('InsuranceName')?.value && InsuCardsFG.get('PolicyNumber')?.value)">
                                * Fields marked with an asterisk are mandatory.
                            </span>

                            <div class="insupopup_footer">
                                <button type="button" class="insu_buttons" (click)="closeInsuPopup()">Cancel</button>
                             <button type="submit" class="insu_buttons" 
                                [disabled]="!(InsuCardsFG.controls['BIN'].value && InsuCardsFG.controls['InsuranceName'].value && InsuCardsFG.controls['PolicyNumber'].value) || isInsuranceExists || isInsuranceInactive" 
                                    [ngClass]="{'input_disabled': !(InsuCardsFG.controls['BIN'].value && InsuCardsFG.controls['InsuranceName'].value && InsuCardsFG.controls['PolicyNumber'].value) || isInsuranceExists || isInsuranceInactive}">Save</button>
                            </div>
                            <div class="insurance_footer">
                                <span class="material-symbols-outlined security">security</span><p>Your information is securely stored and encrypted.</p>
                            </div>
                        </form>
                        <div class="upload-section">
                            <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" style="display: none;" />
                          </div>
                </div>

                <div class="insu_capture_popup" *ngIf="isCaptured">
                    <div class="insupopup_header">
                        <p>Capture Image</p>
                        <button title="cancel" (click)="closeCaptureImagePopup()">×</button>
                    </div>
                    <div class="" *ngIf="!isImageCaptured">
                        <p>Capture the front of your insurance card now.</p>
                    </div>
                    <div class="">
                        <div class="insurance_image_capture">
                            <video #video autoplay playsinline class="insu_camera" *ngIf="!capturedImage"></video>
                            <canvas #canvas style="display: none;" *ngIf="!capturedImage"></canvas>
                            <img *ngIf="capturedImage" [src]="capturedImage" alt="Captured Insurance Image" class="insu_camera_img" />
                        </div>
                    </div>
                    <div class="capture_buttons" *ngIf="!capturedImage">
                        <button class="cap_buttons" (click)="captureAndUploadImage()"><span class="material-symbols-outlined">photo_camera</span><span class="text_change">Capture Image</span>
                        </button>
                    </div>
                    <div class="after_capture_buttons" *ngIf="capturedImage">
                        <button class="cap_buttons" (click)="retry()"><span class="text_change">Retry</span></button>
                        <button class="cap_buttons" (click)="insuranceOCRExtraction()"><span class="text_change">OK</span></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="userInfo userInfo--3">
            <div class="title">Additional Information</div>
            <div class="info">
                <div class="info-item">ID Type
                        <div class="info-value">
                            <div *ngFor="let insuranceItem of patientProfileData?.patientInfo?.insurance">
                                <ng-container *ngIf="insuranceItem.insuPriId === 1"> 
                                        <div>{{ insuranceItem.patientidtype }}</div>  
                                </ng-container>
                            </div>
                        </div>
                </div>
                <div class="info-item">Privacy Acknowledged<div class="info-value">{{(patientProfileData?.patientInfo?.isPatientAck === true) ? "Yes" : "No"}}</div></div>
                <div class="info-item">Delivery Mode Preference<div class="info-value">{{patientProfileData?.patientInfo?.patientInfo?.deliveryMode | titlecase}}</div></div>
                <div class="info-item">Preferred Language<div class="info-value">{{patientProfileData?.patientInfo?.langname | titlecase}}</div></div>
            </div> 
        </div>
        <div class="userInfo userInfo--4">
            <div id="insuranceScroll">
                <div class="title">Allergies</div>
                <div class="info" *ngFor="let items of patallergiesData">
                    <div class="info-item">
                        {{ (items?.description !== null && items?.description !== undefined) ? (items?.description | titlecase) : ((items?.name !== null && items?.name !== undefined) ? (items?.name | titlecase) : 'No Description') }}
                        <div class="info-value"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
<app-profile-edit *ngIf="isPopupVisible" [ProfileImage]="avatarUrl" (onClose)="closePopup($event)"
 [AvatarUrl]="avatarUrl" [PatientProfileData]="patientProfileData">
</app-profile-edit>
</div>
<my-footer></my-footer>
  